// extracted by mini-css-extract-plugin
export default {"VersionsPanel":"VersionsPanel2GkJ3Exj7mQU","VersionsPanel-footer":"VersionsPanel-footer1CFIv3R_yN6n"};